import React from "react";

export default function Velocity() {
  return (
    <section className="py-5 text-center velocity-section" id="services">
      <div className="container">
        <span className="pill-badge mb-3">Our Methodology</span>
        <h1 className="fw-bold">The Velocity Framework</h1>
        <p className="highlight-line">
          Precision-driven delivery for faster adoption, lower risk, and long-term success.
        </p>
        <p className="text-muted mx-auto" style={{ maxWidth: 900 }}>
          We help organizations deploy, stabilize, optimize, and scale workforce
          management solutions using a structured, outcome-driven delivery model
          focused on predictability, quality, and long-term success.
        </p>
      </div>
    </section>
  );
}
